module.exports = __webpack_public_path__ + "img/JJLin.0807207a.jpg";